import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

/**
 * 用户认证状态管理
 * - accessToken / refreshToken 持久化到 localStorage
 * - 提供登录、登出、Token 刷新能力
 */
export const useAuthStore = defineStore('auth', () => {
  const accessToken = ref<string>(localStorage.getItem('accessToken') || '')
  const refreshToken = ref<string>(localStorage.getItem('refreshToken') || '')
  const username = ref<string>(localStorage.getItem('username') || '')

  const isLoggedIn = computed(() => !!accessToken.value)

  function setTokens(access: string, refresh: string) {
    accessToken.value = access
    refreshToken.value = refresh
    localStorage.setItem('accessToken', access)
    localStorage.setItem('refreshToken', refresh)
  }

  function setUsername(name: string) {
    username.value = name
    localStorage.setItem('username', name)
  }

  function logout() {
    accessToken.value = ''
    refreshToken.value = ''
    username.value = ''
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('username')
  }

  return {
    accessToken,
    refreshToken,
    username,
    isLoggedIn,
    setTokens,
    setUsername,
    logout
  }
})
